Object.defineProperty(exports,"__esModule",{value:true});var _omit2=require("lodash/omit");var _omit3=_interopRequireDefault(_omit2);var _defaults2=require("lodash/defaults");var _defaults3=_interopRequireDefault(_defaults2);var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);
var _victoryCore=require("victory-core");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

{

getBarPosition:function getBarPosition(props,datum){
var getDefaultMin=function getDefaultMin(axis){
var defaultMin=_victoryCore.Scale.getType(props.scale[axis])==="log"?
1/Number.MAX_SAFE_INTEGER:0;
return datum["_"+axis]instanceof Date?new Date(defaultMin):defaultMin;
};
var _y0=datum._y0!==undefined?datum._y0:getDefaultMin("y");
var _x0=datum._x0!==undefined?datum._x0:getDefaultMin("x");
return _victoryCore.Helpers.scalePoint(props,(0,_assign3.default)({},datum,{_y0:_y0,_x0:_x0}));
},

getBarStyle:function getBarStyle(datum,baseStyle){
var styleData=(0,_omit3.default)(datum,[
"xName","yName","x","y","label","errorX","errorY","eventKey"]);

return(0,_defaults3.default)({},styleData,baseStyle);
},

getCalculatedValues:function getCalculatedValues(props){var
theme=props.theme,horizontal=props.horizontal,polar=props.polar;
var defaultStyles=theme&&theme.bar&&theme.bar.style?theme.bar.style:{};
var style=_victoryCore.Helpers.getStyles(props.style,defaultStyles);
var data=_victoryCore.Data.getData(props);
var range={
x:_victoryCore.Helpers.getRange(props,"x"),
y:_victoryCore.Helpers.getRange(props,"y")};

var domain={
x:_victoryCore.Domain.getDomainWithZero(props,"x"),
y:_victoryCore.Domain.getDomainWithZero(props,"y")};

var xScale=_victoryCore.Scale.getBaseScale(props,"x").domain(domain.x).range(range.x);
var yScale=_victoryCore.Scale.getBaseScale(props,"y").domain(domain.y).range(range.y);
var scale={
x:horizontal?yScale:xScale,
y:horizontal?xScale:yScale};

var origin=polar?props.origin||_victoryCore.Helpers.getPolarOrigin(props):undefined;
return{style:style,data:data,scale:scale,domain:domain,origin:origin};
},

getBaseProps:function getBaseProps(props,fallbackProps){var _this=this;
var modifiedProps=_victoryCore.Helpers.modifyProps(props,fallbackProps,"bar");
props=(0,_assign3.default)({},modifiedProps,this.getCalculatedValues(modifiedProps));var _props=



props,data=_props.data,domain=_props.domain,events=_props.events,height=_props.height,horizontal=_props.horizontal,origin=_props.origin,padding=_props.padding,polar=_props.polar,scale=_props.scale,sharedEvents=_props.sharedEvents,standalone=_props.standalone,style=_props.style,theme=_props.theme,width=_props.width;
var initialChildProps={parent:{
domain:domain,scale:scale,width:width,height:height,data:data,standalone:standalone,
theme:theme,polar:polar,origin:origin,padding:padding,style:style.parent}};


return data.reduce(function(childProps,datum,index){
var eventKey=datum.eventKey||index;var _getBarPosition=
_this.getBarPosition(props,datum),x=_getBarPosition.x,y=_getBarPosition.y,y0=_getBarPosition.y0,x0=_getBarPosition.x0;
var barStyle=_this.getBarStyle(datum,style.data);
var dataProps={
data:data,datum:datum,horizontal:horizontal,index:index,padding:padding,polar:polar,origin:origin,
scale:scale,style:barStyle,width:width,height:height,x:x,y:y,y0:y0,x0:x0};


childProps[eventKey]={
data:dataProps};


var text=_victoryCore.LabelHelpers.getText(props,datum,index);
if(text!==undefined&&text!==null||events||sharedEvents){
childProps[eventKey].labels=_victoryCore.LabelHelpers.getProps(props,index);
}
return childProps;
},initialChildProps);
}};


//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/lib/components/victory-bar/helper-methods.js
// module id = 1375
// module chunks = 0